import React from 'react';

export default function TermsAndConditions() {
  return (
    <div className="page">
      <div className="container" style={{ maxWidth: '860px', padding: '3rem 2rem' }}>
        <div className="page-header">
          <h1>Terms &amp; Conditions</h1>
          <p>Last updated: May 27, 2026</p>
        </div>

        <div className="static-content">
          {/* SECTION 1 */}
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing, browsing, or using the AstroA2Z platform (web application at astroa2z.com,
              mobile applications, and any associated APIs — collectively, the "Platform"), you
              acknowledge that you have read, understood, and agree to be bound by these Terms &amp;
              Conditions ("Terms"). If you do not agree, you must immediately cease using the Platform.
            </p>
            <p>
              These Terms constitute a legally binding agreement between you ("User", "you") and
              AstroA2Z ("Company", "we", "us", "our"), a technology company registered in India.
            </p>
          </section>

          {/* SECTION 2 — ENTERTAINMENT & NO-GUARANTEE DISCLAIMER */}
          <section>
            <h2>2. Nature of Services — Entertainment Purpose Only</h2>
            <p>
              <strong>AstroA2Z provides astrological information, readings, horoscopes, kundali charts,
              compatibility reports, tarot readings, and related content strictly for entertainment,
              educational, and informational purposes only.</strong>
            </p>
            <p>
              We make <strong>no guarantees, warranties, or promises</strong> regarding the accuracy,
              reliability, or outcome of any astrological reading, prediction, or recommendation
              provided through this Platform. Astrology is not a scientifically proven discipline, and
              all content is inherently subjective and interpretive in nature.
            </p>
            <p>
              <strong>No prediction or reading on this Platform should be construed as a guarantee of
              any future outcome.</strong> Any reliance you place on astrological content is strictly
              at your own risk. We expressly disclaim liability under the Consumer Protection Act, 2019
              for any claims arising from perceived guarantees or assured outcomes.
            </p>
          </section>

          {/* SECTION 3 — AI DISCLOSURE */}
          <section>
            <h2>3. Artificial Intelligence Disclosure</h2>
            <p>
              <strong>Certain readings, interpretations, and content on this Platform are generated
              in whole or in part by artificial intelligence (AI) systems and large language models.</strong>
            </p>
            <p>AI-generated content:</p>
            <ul>
              <li>May contain inaccuracies, hallucinations, or errors</li>
              <li>Is not reviewed by qualified astrologers before delivery in real-time features</li>
              <li>Should not be treated as expert advice of any kind</li>
              <li>Is generated algorithmically and does not constitute a human professional opinion</li>
              <li>May vary in output even for identical inputs due to the probabilistic nature of AI</li>
            </ul>
            <p>
              You acknowledge and accept that AI-generated content is provided "as is" without any
              warranty of accuracy, completeness, or fitness for a particular purpose.
            </p>
            <p>
              <strong>AstroA2Z is not responsible or liable for any predictions, interpretations,
              errors, inaccuracies, or omissions in AI-generated content.</strong> Such content is
              produced by third-party AI models and large language models whose outputs are beyond
              our direct control. Errors, hallucinations, and inaccuracies are inherent limitations
              of the underlying AI technology provided by respective model providers. We disclaim
              all liability for any reliance placed on, or decisions made based on, AI-generated
              outputs.
            </p>
          </section>

          {/* SECTION 4 — MEDICAL DISCLAIMER */}
          <section>
            <h2>4. Medical &amp; Health Disclaimer</h2>
            <p>
              <strong>The Platform does NOT provide medical advice.</strong> No astrological reading,
              AI-generated interpretation, or content on this Platform constitutes medical diagnosis,
              treatment recommendation, or healthcare advice.
            </p>
            <p><strong>You must:</strong></p>
            <ul>
              <li>
                <strong>Never delay, avoid, or disregard professional medical advice</strong> because
                of any content you have read or received on this Platform
              </li>
              <li>
                Always consult a qualified medical practitioner for any health concerns, symptoms, or
                conditions
              </li>
              <li>
                Not use any astrological reading as a basis for starting, stopping, or altering any
                medication, treatment, or health regimen
              </li>
              <li>
                Seek immediate emergency medical assistance if you are experiencing a medical emergency
              </li>
            </ul>
            <p>
              In compliance with the Drugs &amp; Magic Remedies (Objectionable Advertisements) Act,
              1954, we do not claim that any service on this Platform can diagnose, cure, mitigate,
              treat, or prevent any disease or medical condition. Any health-related content is
              purely for general informational interest and must not be relied upon.
            </p>
          </section>

          {/* SECTION 5 — FINANCIAL DISCLAIMER */}
          <section>
            <h2>5. Financial &amp; Investment Disclaimer</h2>
            <p>
              <strong>Nothing on this Platform constitutes financial advice, investment advice, trading
              advice, or any recommendation to buy, sell, or hold any financial instrument, security,
              cryptocurrency, or asset.</strong>
            </p>
            <p>
              We are not registered with the Securities and Exchange Board of India (SEBI), the Reserve
              Bank of India (RBI), or any other financial regulatory body as an investment advisor,
              research analyst, or portfolio manager. No content, reading, or prediction on this
              Platform should be used to make financial or investment decisions.
            </p>
            <p>
              You acknowledge that you will not hold AstroA2Z liable for any financial losses,
              damages, or consequences arising from decisions made based on content available on this
              Platform. Always consult a SEBI-registered investment advisor or qualified financial
              professional before making investment decisions.
            </p>
          </section>

          {/* SECTION 6 — LEGAL DISCLAIMER */}
          <section>
            <h2>6. Legal &amp; Professional Advice Disclaimer</h2>
            <p>
              This Platform does not provide legal, tax, accounting, or any other professional advice.
              For specific professional guidance, always engage a qualified, licensed professional in
              the relevant field.
            </p>
          </section>

          {/* SECTION 7 — USER ACCOUNTS */}
          <section>
            <h2>7. User Accounts &amp; Eligibility</h2>
            <p>
              To access certain features, you must create an account. You must be at least 18 years
              of age (or the age of majority in your jurisdiction) to create an account. By creating
              an account, you represent that you meet this age requirement.
            </p>
            <p>You are responsible for:</p>
            <ul>
              <li>Maintaining the confidentiality of your login credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately at security@astroa2z.com of any unauthorized access</li>
              <li>Ensuring that information you provide is accurate and current</li>
            </ul>
          </section>

          {/* SECTION 8 — CONSENT FOR DATA */}
          <section>
            <h2>8. Consent for Personal &amp; Sensitive Data</h2>
            <p>
              Our services require birth data (date, time, and place of birth) to generate astrological
              calculations. By providing this data, you give explicit, informed, and freely given
              consent for us to process it solely for the purposes described in our{' '}
              <a href="/privacy-policy">Privacy Policy</a>.
            </p>
            <p>
              You must not submit birth data or personal information of any third party without
              obtaining their prior written consent. You represent and warrant that you have lawful
              authority to provide any third-party data you submit.
            </p>
            <p>
              In accordance with the Digital Personal Data Protection Act, 2023 (DPDP Act), we
              process your data only for specified, lawful purposes and with your consent. See our
              Privacy Policy for full details on your rights under the DPDP Act.
            </p>
          </section>

          {/* SECTION 9 — SUBSCRIPTION & PAYMENTS */}
          <section>
            <h2>9. Subscriptions, Payments &amp; Pricing</h2>
            <p>
              Certain features require a paid subscription. By subscribing, you agree to pay the
              fees displayed at the time of purchase. All prices are in Indian Rupees (INR) unless
              otherwise stated and are inclusive of applicable GST.
            </p>
            <p>
              Subscriptions auto-renew at the end of each billing period unless cancelled before
              the renewal date. You may cancel auto-renewal at any time through your account settings.
            </p>
          </section>

          {/* SECTION 10 — REFUND POLICY */}
          <section>
            <h2>10. Refund &amp; Cancellation Policy</h2>
            <p>
              In compliance with the Consumer Protection (E-Commerce) Rules, 2020, we offer the
              following refund terms:
            </p>
            <h3>10.1 Cooling-Off Period</h3>
            <p>
              You may cancel any new subscription within <strong>48 hours</strong> of purchase for a
              full refund, no questions asked. This applies to first-time subscriptions and upgrades.
            </p>
            <h3>10.2 Pro-Rata Refunds (Within 7 Days)</h3>
            <p>
              If you cancel between 48 hours and 7 days from the date of purchase, you are entitled
              to a pro-rata refund for the unused portion of your subscription period.
            </p>
            <h3>10.3 After 7 Days</h3>
            <p>
              Cancellations after 7 days will stop future billing but no refund will be issued for
              the current billing period. You will continue to have access until the end of your
              paid period.
            </p>
            <h3>10.4 One-Time Purchases</h3>
            <p>
              One-time purchases (individual readings, reports) are refundable within 48 hours if
              the service has not been delivered or accessed. Once a reading or report has been
              generated and viewed, it is considered delivered.
            </p>
            <h3>10.5 How to Request a Refund</h3>
            <p>
              Email <a href="mailto:support@astroa2z.com">support@astroa2z.com</a> with your account
              email and order details. Refunds are processed within 5–7 business days to the original
              payment method.
            </p>
          </section>

          {/* SECTION 11 — PRIEST SERVICES */}
          <section>
            <h2>11. Priest &amp; Puja Booking Services</h2>
            <p>
              AstroA2Z facilitates connections between users and independent priests/pandits for puja
              and ritual services. Priests are independent service providers, not employees of AstroA2Z.
            </p>
            <p>
              We do not guarantee the quality, outcome, or spiritual efficacy of any ritual or puja
              performed. Cancellation and refund for priest bookings are governed by the specific
              booking terms displayed at the time of booking.
            </p>
          </section>

          {/* SECTION 12 — PROHIBITED USES */}
          <section>
            <h2>12. Prohibited Uses</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use our services for any unlawful or fraudulent purpose</li>
              <li>Scrape, crawl, or use automated means to access the Platform without authorization</li>
              <li>Attempt to reverse-engineer our AI models or algorithms</li>
              <li>Reproduce, distribute, or commercially exploit our content without written permission</li>
              <li>Upload malicious code, viruses, or interfere with Platform operations</li>
              <li>Harass, abuse, defame, or harm other users or priests</li>
              <li>Impersonate any person or entity</li>
              <li>Submit false, misleading, or fabricated data</li>
              <li>Use the Platform to make decisions that may harm yourself or others without seeking
                appropriate professional counsel</li>
            </ul>
          </section>

          {/* SECTION 13 — INTELLECTUAL PROPERTY */}
          <section>
            <h2>13. Intellectual Property</h2>
            <p>
              All content, software, designs, logos, trademarks, text, graphics, and materials on
              the Platform are the property of AstroA2Z or its licensors and are protected under
              the Copyright Act, 1957, the Trade Marks Act, 1999, and applicable international
              intellectual property laws.
            </p>
            <p>
              You are granted a limited, non-exclusive, non-transferable, revocable license to
              access and use the Platform for personal, non-commercial purposes only.
            </p>
          </section>

          {/* SECTION 14 — LIMITATION OF LIABILITY */}
          <section>
            <h2>14. Limitation of Liability</h2>
            <p>To the maximum extent permitted by applicable Indian law:</p>
            <ul>
              <li>
                AstroA2Z shall not be liable for any indirect, incidental, special, consequential,
                punitive, or exemplary damages arising from your use of the Platform
              </li>
              <li>
                We are not liable for any decisions made based on astrological content, including
                but not limited to medical, financial, legal, or personal decisions
              </li>
              <li>
                Our total aggregate liability for any claims arising under these Terms shall not
                exceed the amount paid by you to AstroA2Z in the twelve (12) months preceding the
                claim, or INR 5,000, whichever is lower
              </li>
              <li>
                We are not liable for any service interruptions, data loss, or technical failures
                beyond our reasonable control
              </li>
            </ul>
          </section>

          {/* SECTION 15 — INDEMNIFICATION */}
          <section>
            <h2>15. Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless AstroA2Z, its directors, officers,
              employees, agents, and affiliates from and against all claims, damages, losses,
              liabilities, costs, and expenses (including legal fees) arising from:
            </p>
            <ul>
              <li>Your use of the Platform or violation of these Terms</li>
              <li>Your violation of any third-party rights</li>
              <li>Any third-party data you submitted without proper consent</li>
              <li>Any decisions or actions you took based on Platform content</li>
            </ul>
          </section>

          {/* SECTION 16 — TERMINATION */}
          <section>
            <h2>16. Termination</h2>
            <p>
              We may suspend or terminate your access to the Platform at our sole discretion,
              with or without notice, for conduct that violates these Terms, is harmful to other
              users, or is otherwise objectionable. Upon termination:
            </p>
            <ul>
              <li>Your right to use the Platform ceases immediately</li>
              <li>We may delete your account data in accordance with our data retention policies</li>
              <li>Sections that by their nature should survive termination shall survive (including
                disclaimers, limitation of liability, indemnification, and governing law)</li>
            </ul>
          </section>

          {/* SECTION 17 — GOVERNING LAW & JURISDICTION */}
          <section>
            <h2>17. Governing Law &amp; Jurisdiction</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of India,
              without regard to conflict of law principles.
            </p>
            <p>
              <strong>Any disputes, claims, or controversies arising out of or relating to these Terms
              or the Platform shall be subject to the exclusive jurisdiction of the courts located in
              Hyderabad, Telangana, India.</strong>
            </p>
            <p>
              Before initiating any legal proceedings, you agree to attempt to resolve disputes
              amicably by contacting us at <a href="mailto:legal@astroa2z.com">legal@astroa2z.com</a>.
              Both parties agree to a 30-day mediation period before filing any suit.
            </p>
          </section>

          {/* SECTION 18 — CONSUMER PROTECTION COMPLIANCE */}
          <section>
            <h2>18. Consumer Protection Compliance</h2>
            <p>
              In compliance with the Consumer Protection Act, 2019, and the Consumer Protection
              (E-Commerce) Rules, 2020:
            </p>
            <ul>
              <li>All prices are displayed transparently with no hidden charges</li>
              <li>We provide clear grievance redressal mechanisms (see Section 22)</li>
              <li>We do not engage in unfair trade practices or misleading advertisements</li>
              <li>All services are described accurately without exaggeration of benefits</li>
              <li>We do not guarantee any outcome from astrological services</li>
            </ul>
          </section>

          {/* SECTION 19 — DPDP ACT COMPLIANCE */}
          <section>
            <h2>19. Digital Personal Data Protection (DPDP) Act, 2023 Compliance</h2>
            <p>We are committed to compliance with the DPDP Act, 2023. Under these Terms:</p>
            <ul>
              <li>
                <strong>Purpose Limitation:</strong> Your personal data is collected and processed
                only for specific, clearly stated purposes (astrological calculations, account
                management, service delivery)
              </li>
              <li>
                <strong>Data Minimization:</strong> We collect only the minimum data necessary to
                provide our services
              </li>
              <li>
                <strong>Storage Limitation:</strong> Data is retained only as long as necessary for
                the stated purpose or as required by law
              </li>
              <li>
                <strong>Right to Erasure:</strong> You may request deletion of your personal data
                at any time. Deletion is a soft-delete (account deactivated, data retained for 30
                days for recovery, then permanently purged). Soft-deleted data will NOT be used for
                marketing or advertising. See Privacy Policy for details.
              </li>
              <li>
                <strong>Consent Withdrawal:</strong> You may withdraw consent at any time, after which
                we will cease processing your data (this may result in inability to use certain services)
              </li>
              <li>
                <strong>Data Principal Rights:</strong> You have rights to access, correction, and
                grievance redressal as defined under the DPDP Act
              </li>
            </ul>
          </section>

          {/* SECTION 20 — IT ACT COMPLIANCE */}
          <section>
            <h2>20. Information Technology Act, 2000 Compliance</h2>
            <p>
              This Platform is an "intermediary" as defined under the Information Technology Act, 2000,
              and the Information Technology (Intermediary Guidelines and Digital Media Ethics Code)
              Rules, 2021. We observe due diligence and comply with all applicable provisions including
              content takedown obligations and user grievance mechanisms.
            </p>
          </section>

          {/* SECTION 21 — FORCE MAJEURE */}
          <section>
            <h2>21. Force Majeure</h2>
            <p>
              AstroA2Z shall not be liable for any failure or delay in performing obligations under
              these Terms caused by events beyond our reasonable control, including natural disasters,
              government actions, internet outages, cyberattacks, pandemics, or acts of God.
            </p>
          </section>

          {/* SECTION 22 — GRIEVANCE REDRESSAL */}
          <section>
            <h2>22. Grievance Redressal</h2>
            <p>
              In accordance with the Consumer Protection Act, 2019, and the IT Act, 2000, we have
              appointed a Grievance Officer:
            </p>
            <p>
              <strong>Grievance Officer:</strong> AstroA2Z Support Team<br />
              <strong>Email:</strong>{' '}
              <a href="mailto:grievance@astroa2z.com">grievance@astroa2z.com</a><br />
              <strong>Response Time:</strong> We acknowledge grievances within 24 hours and resolve
              them within 15 days of receipt.
            </p>
          </section>

          {/* SECTION 23 — SEVERABILITY */}
          <section>
            <h2>23. Severability</h2>
            <p>
              If any provision of these Terms is found to be invalid, illegal, or unenforceable by a
              court of competent jurisdiction, the remaining provisions shall continue in full force
              and effect. The invalid provision shall be modified to the minimum extent necessary to
              make it valid and enforceable.
            </p>
          </section>

          {/* SECTION 24 — ENTIRE AGREEMENT */}
          <section>
            <h2>24. Entire Agreement</h2>
            <p>
              These Terms, together with our Privacy Policy and any other policies referenced herein,
              constitute the entire agreement between you and AstroA2Z regarding your use of the
              Platform and supersede all prior agreements and understandings.
            </p>
          </section>

          {/* SECTION 25 — CHANGES TO TERMS */}
          <section>
            <h2>25. Changes to These Terms</h2>
            <p>
              <strong>AstroA2Z reserves the absolute and unconditional right to amend, modify,
              update, or replace these Terms &amp; Conditions at any point in time, at its sole
              discretion, without prior notice.</strong> Changes may include but are not limited to
              modifications in service scope, pricing, refund policies, usage rules, liability
              clauses, and any other provision herein.
            </p>
            <p>
              We will make reasonable efforts to notify you of material changes via email or a
              prominent notice on the Platform. However, it is your sole responsibility to review
              these Terms periodically for updates.
            </p>
            <p>
              <strong>By continuing to access or use the Platform after any changes are posted,
              you are deemed to have accepted and agreed to be bound by the revised Terms in their
              entirety.</strong> You are obligated to comply with the most current version of these
              Terms at all times. If you do not agree to the modified Terms, your sole remedy is to
              immediately discontinue use of the Platform and delete your account.
            </p>
          </section>

          {/* SECTION 26 — CONTACT */}
          <section>
            <h2>26. Contact Information</h2>
            <p>
              For questions about these Terms, contact us at:<br />
              <strong>Email:</strong>{' '}
              <a href="mailto:legal@astroa2z.com">legal@astroa2z.com</a><br />
              <strong>Support:</strong>{' '}
              <a href="mailto:support@astroa2z.com">support@astroa2z.com</a><br />
              <strong>Website:</strong> https://astroa2z.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
